import React from 'react';

// Standard admin2 card: rounded-2xl white surface with the design-system
// border/shadow (see fact-find-test/primitives/CategoryCard.js).
const Card = ({ title, subtitle, actions, icon, children, className = '', bodyClassName = '' }) => {
    const hasHeader = title || subtitle || actions;
    return (
        <section className={`rounded-2xl bg-white shadow-sm border border-[#E5E7EB] ${className}`}>
            {hasHeader ? (
                <header className="px-5 sm:px-6 pt-5 pb-4 border-b border-[#F0F1F5] flex flex-wrap items-center justify-between gap-3">
                    <div className="flex items-center gap-3 min-w-0">
                        {icon ? (
                            <span
                                className="inline-flex items-center justify-center h-10 w-10 rounded-xl flex-shrink-0"
                                style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
                            >
                                {icon}
                            </span>
                        ) : null}
                        <div className="min-w-0">
                            {title ? <h3 className="text-base font-bold text-[#1F2937] truncate">{title}</h3> : null}
                            {subtitle ? <p className="text-xs text-[#6B7280] mt-0.5">{subtitle}</p> : null}
                        </div>
                    </div>
                    {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
                </header>
            ) : null}
            <div className={`${bodyClassName || 'p-5 sm:p-6'}`}>{children}</div>
        </section>
    );
};

export default Card;
